import { Outlet } from 'react-router-dom'
import { Navigation } from './Navigation'
import { SocialLinks } from './SocialLinks'
import { socialLinks, personalInfo } from '../lib/content'

function FloatingShapes() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Floating geometric shapes - subtle, blurred, drifting slowly */}
      <svg className="floating-shape w-32 h-32 text-orange-500" viewBox="0 0 24 24" fill="currentColor">
        <polygon points="12,2 22,20 2,20" />
      </svg>
      <svg className="floating-shape w-24 h-24 text-slate-500" viewBox="0 0 24 24" fill="currentColor">
        <rect x="4" y="4" width="16" height="16" rx="2" />
      </svg>
      <svg className="floating-shape w-40 h-40 text-orange-400" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="12" r="10" />
      </svg>
      <svg className="floating-shape w-28 h-28 text-slate-400" viewBox="0 0 24 24" fill="currentColor">
        <polygon points="12,2 15,9 22,9 17,14 19,22 12,17 5,22 7,14 2,9 9,9" />
      </svg>
      <svg className="floating-shape w-20 h-20 text-orange-500" viewBox="0 0 24 24" fill="currentColor">
        <polygon points="12,2 22,20 2,20" />
      </svg>
      <svg className="floating-shape w-36 h-36 text-slate-500" viewBox="0 0 24 24" fill="currentColor">
        <polygon points="12,2 22,8.5 22,15.5 12,22 2,15.5 2,8.5" />
      </svg>
      <svg className="floating-shape w-24 h-24 text-orange-400" viewBox="0 0 24 24" fill="currentColor">
        <rect x="4" y="4" width="16" height="16" transform="rotate(45 12 12)" />
      </svg>
      <svg className="floating-shape w-32 h-32 text-slate-400" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="12" r="10" />
      </svg>

      {/* Glowing orbs */}
      <div className="glow-orb glow-orb-orange w-64 h-64 top-20 right-10" style={{ animationDelay: '0s' }} />
      <div className="glow-orb glow-orb-slate w-48 h-48 top-1/3 left-10" style={{ animationDelay: '1s' }} />
      <div className="glow-orb glow-orb-orange w-56 h-56 bottom-20 left-1/3" style={{ animationDelay: '2s' }} />
      <div className="glow-orb glow-orb-slate w-40 h-40 top-1/2 right-1/4" style={{ animationDelay: '1.5s' }} />
    </div>
  )
}

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-900 transition-colors duration-300 relative overflow-hidden">
      {/* Background decorations */}
      <div className="fixed inset-0 bg-gradient-mesh pointer-events-none" />

      {/* Animated floating shapes */}
      <FloatingShapes />

      {/* Animated gradient blobs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-orange-400/10 dark:bg-orange-500/5 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl animate-blob" />
        <div className="absolute top-1/3 -left-40 w-96 h-96 bg-slate-400/10 dark:bg-slate-500/5 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl animate-blob animation-delay-2000" />
        <div className="absolute -bottom-40 left-1/2 w-96 h-96 bg-orange-300/10 dark:bg-orange-600/5 rounded-full mix-blend-multiply dark:mix-blend-screen filter blur-3xl animate-blob animation-delay-4000" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col min-h-screen">
        <Navigation />

        <main className="flex-grow">
          <Outlet />
        </main>

        <footer className="bg-white/70 dark:bg-slate-800/70 backdrop-blur-md border-t border-slate-200/50 dark:border-slate-700/50">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-slate-600 dark:text-slate-400 text-sm">
                &copy; {new Date().getFullYear()} {personalInfo.name}. All rights reserved.
              </p>
              <SocialLinks links={socialLinks} size="sm" />
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}
